import React from "react";

export default function Hireme() {
  return <div>hireMe</div>;
}
